var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AddAgencyForm',{attrs:{"submitUrl":"/api/register/set-up-agency","onSuccessfulSubmit":_vm.handleSuccessfulSubmit},scopedSlots:_vm._u([{key:"progress-bar",fn:function(){return [_c('CompleteSignupProgressRegular',{attrs:{"currentStep":2}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }